import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, DatePicker, TimePicker } from "antd";
import { useRef } from "react";
import Status from "redux/models/status";
import K from "utilities/constants";
import {
  convertDateStringToMoment,
  convertTimeStringToMoment,
} from "utilities/dateUtility";

export default function EditDate({
  dateKey,
  dateString,
  onCancel,
  candidateJobEntryId,
  onUpdated,
  isTime = false,
  isOtherItem = false, // This check creates and difference between the date field and other components
  itemType = K.EditComponentType.boolean,
}) {
  const dateRef = useRef(dateString); // this reference is used for both component date component and other component;

  const onChange = (dateObj) => {
    dateRef.current = dateObj
      ? isTime
        ? dateObj.format(K.TimeFomat.Response)
        : dateObj.format(K.DateFormat.Response)
      : null;
  };

  const checkboxOnChange = (obj) => {
    dateRef.current = obj.target.checked;
  };

  const changeStatusDate = async () => {
    if (dateString === dateRef.current) {
      onCancel();
      return;
    }

    const payload = { candidateJobEntryId, [dateKey]: dateRef.current };
    try {
      const res = await Status.changeCandidateStatusDate(payload);
      onUpdated(dateRef.current, res);
      onCancel();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {isOtherItem ? (
        <>
          {itemType === K.EditComponentType.CheckBox && (
            <Checkbox defaultChecked={dateString} onChange={checkboxOnChange} />
          )}
        </>
      ) : !isTime ? (
        <DatePicker
          onChange={onChange}
          format={K.DateFormat.DashUSFormat}
          defaultValue={convertDateStringToMoment(dateString)}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        />
      ) : (
        <TimePicker
          use12Hours
          onChange={onChange}
          format={K.TimeFomat.Display}
          defaultValue={convertTimeStringToMoment(dateString)}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        />
      )}
      <Button
        type="link"
        onClick={onCancel}
        icon={<CloseCircleOutlined className="closeIcon" />}
      />
      <Button
        type="link"
        onClick={changeStatusDate}
        icon={<CheckCircleOutlined className="checkIcon" />}
      />
    </>
  );
}
